"use client";

import { useQuery } from "@tanstack/react-query";
import { getSdk } from "../sdk";
import { qk } from "../query-keys";

// Signup/verify bonus + credit packs. Server-config driven and rarely changes,
// so we cache hard (1h) — the dashboard completion nudge and the buy-credits
// modal both read the same source of truth instead of hardcoding amounts.
export function usePublicPricing() {
  return useQuery({
    queryKey: qk.public.pricing,
    queryFn: async () => getSdk().public.pricing(),
    staleTime: 60 * 60_000,
  });
}
